import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item"]

  filter(event) {
    const query = event.target.value.toLowerCase()
    this.applyFilter(query)
  }

  filterButton(event) {
    event.preventDefault()
    const input = event.target.closest('div').querySelector('input[type="text"]')
    if (input) {
      const query = input.value.toLowerCase()
      this.applyFilter(query)
    }
  }

  applyFilter(query) {
    this.itemTargets.forEach(el => {
      const value = el.dataset.value
      el.classList.toggle("hidden", !value.includes(query))
    })
  }
}
